module.exports = __webpack_public_path__ + "static/media/avon.33cd377b.png";